<div class="mx-2 ta-c">
    <div class="mat-display-3 mt-4 mb-2">Games</div>

    <div class="mat-title">My pride and joy</div>
    <div class="mat-subheading-2 mb-4">These games were made for various game jams, and are free to play!</div>

    <div *ngFor="let game of games" class="mb-2">
        <iframe [src]="getSafeEmbedUrl(game)" height="167" [width]="compactView ? 210 : 552" frameborder="0">
            <a [href]="getSafeGameUrl(game)">{{ game.name }} by Jevansmassive</a>
        </iframe>
    </div>
</div>